/**
 * Reusable exercise card.
 * Note: NEVER autoload videos here — only thumbnails. Per spec.
 */
import { motion } from "framer-motion";

const DIFF_COLOR = {
  beginner: "var(--accent-green)",
  intermediate: "#FFB257",
  advanced: "#FF5C5C",
};

export default function ExerciseCard({ exercise, onClick, action }) {
  const dotColor = DIFF_COLOR[exercise.difficulty] || "var(--text-muted)";
  return (
    <motion.button
      type="button"
      onClick={onClick}
      whileHover={{ y: -2 }}
      data-testid={`exercise-card-${exercise.exercise_id}`}
      className="text-left bg-white rounded-[16px] overflow-hidden border border-line2 transition-shadow hover:shadow-card w-full"
      style={{ boxShadow: "var(--shadow-soft)" }}
    >
      <div className="flex items-stretch gap-3">
        <div
          className="w-24 h-24 shrink-0 bg-canvas2 bg-cover bg-center"
          style={{ backgroundImage: `url(${exercise.thumbnail_url})` }}
        />
        <div className="flex-1 min-w-0 py-3 pr-3 flex flex-col justify-between">
          <div>
            <div className="flex items-start justify-between gap-2">
              <h3 className="font-display text-[16px] leading-tight truncate">{exercise.name}</h3>
              <span
                className="w-2 h-2 rounded-full mt-2 shrink-0"
                style={{ background: dotColor }}
                aria-label={exercise.difficulty}
              />
            </div>
            <div className="flex flex-wrap gap-1.5 mt-1.5">
              <span className="text-[11px] px-2 py-0.5 rounded-full bg-canvas2 text-ink-soft capitalize">
                {exercise.muscle_group}
              </span>
              <span className="text-[11px] px-2 py-0.5 rounded-full bg-canvas2 text-ink-soft capitalize">
                {exercise.equipment}
              </span>
            </div>
          </div>
          <div className="flex items-center justify-between">
            {action ?? (
              <span className="text-[12px] text-ink-muted capitalize">{exercise.difficulty}</span>
            )}
          </div>
        </div>
      </div>
    </motion.button>
  );
}
